<template>
  <div>
    <div class="section">
      <el-form :disabled="readonly" :inline="true" label-position="left" label-width="75px">
        <el-checkbox v-model="job.usCustomsClearance" no="usCustomsClearance">{{ $t('queryJob.UsCustomsClearance') }}</el-checkbox>
        <el-checkbox v-model="job.insure" no="isInsure" style="margin-left: -20px;">{{ $t('SeaExport.InsureInfo') }} </el-checkbox>
        <span
          id="toInsure"
          v-permission="['button_insurance_toInsure']"
          type="primary"
          :class="!isEdit?'el-button el-button--primary el-button--mini':'el-button el-button--primary el-button--mini is-disabled'"
          style="min-width:50px!important;margin-left:15px"
          @click="()=>{if (!isEdit){toInsure()}}"
        >{{ $t('SeaExport.Insure') }}
        </span>
        <span v-if="!!templateName" class="blue" style="float: right;margin-right: 30px;line-height: 28px;padding: 0 5px;white-space: nowrap;">{{ $t('CargoMsg.Cargo_SopTemplate') }}: {{ templateName }}</span>
      </el-form>
    </div>
    <tab-booking-master-UICustom-layout :element-blocks="elementBlocks">
      <el-form-item v-if="elementDict.jobNo.masterVisible" slot="jobNo">
        <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
        <el-input v-model="job.jobNo" :disabled="true" no="jobNo" />
      </el-form-item>
      <template v-if="elementDict.mbl.masterVisible" slot="mbl">
        <el-form-item>
          <line-label slot="label" :class="elementDict.mbl.isRequire ? 'blue' : ''" :label="elementDict.mbl.label" />
          <el-checkbox v-model="job.express" :disabled="readonly" no="express">{{ $t('SeaExport.ExpressInfo') }}</el-checkbox>
        </el-form-item>
        <el-form-item label=" ">
          <el-tooltip :content="(job.express||mblCodeNumValidate)?'':$t('queryJob.TheDoesNotComplyRules')" placement="right-end">
            <div style="display: flex;">
              <cargo-input
                v-show="job.express"
                v-model="job.mbl"
                :disabled="readonly"
                no="mbl"
                :maxlength="32"
                :input-convert="filterNonDigit"
                style="width: 170px;flex-grow: 1;"
              />
              <cargo-input
                v-show="!job.express"
                :value="mblCode"
                :disabled="readonly"
                no="mblCode"
                :maxlength="3"
                :input-convert="filterNonDigit"
                :class="mblCodeNumValidate?'':'red'"
                style="width: 60px;flex-grow: 1;"
                @input="onMblCodeInput"
                @blur="onMblCodeNumBlur"
              />
              <span v-show="!job.express" style="padding-right: 2.5px;padding-left: 2.5px;">-</span>
              <cargo-input
                v-show="!job.express"
                ref="mblNum"
                v-model="mblNum"
                :disabled="readonly"
                no="mblNum"
                :maxlength="8"
                :input-convert="filterNonDigit"
                :class="mblCodeNumValidate?'':'red'"
                style="width: 108px;flex-grow: 1;"
                @blur="onMblCodeNumBlur"
              />
            </div>
          </el-tooltip>
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.jobSoNo.masterVisible" slot="jobSoNo">
        <line-label slot="label" :class="elementDict.jobSoNo.isRequire ? 'blue' : ''" :label="elementDict.jobSoNo.label" />
        <so-no-input v-model="job.jobSoNo" :disabled="readonly" no="jobSoNo" />
      </el-form-item>
      <el-form-item v-if="elementDict.customerRefNo.masterVisible" slot="customerRefNo">
        <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
        <cargo-input v-model="job.customerRefNo" no="customerRefNo" :disabled="readonly" :auto-uppercase="true" :trim="true" />
      </el-form-item>
      <template v-if="isZY">
        <el-form-item slot="saleProductCode">
          <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_AllowSaleProduct"
            :disabled="readonly"
            filterable
            no="allowSaleProduct"
            clearable
            :data-filter-function="p => p.statusEnabled && p.airImportEnabled"
            :default-value="job.saleProductCode || ''"
            @parentCallBack="p => {job.saleProductCode = p.value}"
          />
        </el-form-item>
        <el-form-item slot="fullOrInside">
          <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
          <cargo-advance-select
            :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
            :disabled="readonly"
            no="fullOrInside"
            clearable
            :default-value="job.fullOrInside || ''"
            @parentCallBack="p => {job.fullOrInside = p.value}"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.cargoSource.masterVisible" slot="cargoSource">
        <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
        <cargo-advance-select
          no="cargoSource"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.local_cache_CargoSource"
          callback-method-type="value"
          :default-value="job.cargoSource"
          :callback-params="{key:'cargoSource'}"
          :clearable="false"
          placeholder=" "
          @parentCallBack="cargoSource_Change"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customJobType.masterVisible" slot="customJobType">
        <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
        <cargo-advance-select
          no="customJobType"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_CutomJobType"
          :default-value="job.customJobType"
          :tag-name="isZh?'name':'englishName'"
          :static-options="customJobTypeList"
          :method-params="{type:job.lob}"
          placeholder=" "
          @parentCallBack="p=>{job.customJobType=p.value;onCustomJobTypeChange(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.secondaryCustomJobType.masterVisible && job.customJobType && secondaryCustomJobTypeList.length > 0" slot="secondaryCustomJobType">
        <line-label slot="label" :class="elementDict.secondaryCustomJobType.isRequire ? 'blue' : ''" :label="elementDict.secondaryCustomJobType.label" />
        <cargo-advance-select
          ref="secondaryCustomJobType"
          no="secondaryCustomJobType"
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_CutomJobType"
          filterable
          :cache="false"
          :default-value="job.secondaryCustomJobType"
          :tag-name="$store.getters.language === 'zh'?'name':'englishName'"
          :static-options="secondaryCustomJobTypeList"
          @parentCallBack="p=>{job.secondaryCustomJobType=p.value}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.designationAgent.masterVisible && job.cargoSource==='NC'" slot="designationAgent">
        <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
        <cargo-advance-select
          no="designationAgent"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{overseaAgent:true,active:true}"
          :default-value="job.designationAgent ||''"
          tag-name="englishName"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="designationAgentChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.salesChannel.masterVisible" slot="salesChannel">
        <line-label slot="label" :class="elementDict.salesChannel.isRequire ? 'blue' : ''" :label="elementDict.salesChannel.label" />
        <el-input v-model="job.salesChannel" :disabled="true" no="salesChannel" />
      </el-form-item>
      <el-form-item v-if="elementDict.trustFromJob && elementDict.trustFromJob.masterVisible" slot="trustFromJob">
        <line-label slot="label" :class="elementDict.trustFromJob.isRequire ? 'blue' : ''" :label="elementDict.trustFromJob.label" />
        <el-input v-model="job.trustFromJob" no="trustFromJob" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.relatedJob && elementDict.relatedJob.masterVisible" slot="relatedJob">
        <line-label slot="label" :class="elementDict.relatedJob.isRequire ? 'blue' : ''" :label="elementDict.relatedJob.label" />
        <el-input v-model="job.relatedJob" no="relatedJob" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.loadingAgentId.masterVisible" slot="loadingAgentId">
        <line-label slot="label" :class="elementDict.loadingAgentId.isRequire ? 'blue' : ''" :label="elementDict.loadingAgentId.label" />
        <cargo-advance-select
          no="loadingAgentId"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{overseaAgent:true,active:true}"
          :callback-params="{key:'loadingAgentId'}"
          callback-method-type="value"
          tag-name="englishName"
          :default-value="job.loadingAgentId ||''"
          placeholder=" "
          @parentCallBack="p=>{
            setJobSelectNum(p)
            OverseaCustomerUtils.destinationAgentChangeHandler(view)
          }"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.carrierId.masterVisible" slot="carrierId">
        <line-label slot="label" :class="elementDict.carrierId.isRequire ? 'blue' : ''" :label="elementDict.carrierId.label" />
        <cargo-advance-select
          no="carrierId"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{airCmp:true,active:true}"
          :default-value="job.carrierId ||''"
          placeholder=" "
          @parentCallBack="txtCarrierId_changeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.voyageFlight.masterVisible" slot="voyageFlight">
        <line-label slot="label" :class="elementDict.voyageFlight.isRequire ? 'blue' : ''" :label="elementDict.voyageFlight.label" />
        <cargo-input v-model="job.voyageFlight" :disabled="readonly" no="voyageFlight" :auto-uppercase="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingAgent.masterVisible && bookingAgentVisible" slot="bookingAgent">
        <line-label slot="label" :class="elementDict.bookingAgent.isRequire ? 'blue' : ''" :label="elementDict.bookingAgent.label" />
        <cargo-advance-select
          no="bookingAgent"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{bookingAgent:true,active:true}"
          :callback-params="{key:'bookingAgent'}"
          callback-method-type="value"
          :default-value="job.bookingAgent ||''"
          placeholder=" "
          @parentCallBack="obj=>{setJobSelectNum(obj);job.groundAgentId=job.bookingAgent}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.exChangeAgent.masterVisible" slot="exChangeAgent">
        <line-label slot="label" :class="elementDict.exChangeAgent.isRequire ? 'blue' : ''" :label="elementDict.exChangeAgent.label" />
        <cargo-advance-select
          no="exChangeAgent"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{bookingAgent:true,active:true}"
          :callback-params="{key:'exChangeAgent'}"
          callback-method-type="value"
          :default-value="job.exChangeAgent ||''"
          placeholder=" "
          @parentCallBack="obj=>{setJobSelectNum(obj)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dispatchingPlace.masterVisible" slot="dispatchingPlace">
        <line-label slot="label" :class="elementDict.dispatchingPlace.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlace.label" />
        <cargo-input v-model="job.dispatchingPlace" :disabled="readonly" no="dispatchingPlace" :auto-uppercase="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.loadingPortCode.masterVisible" slot="loadingPortCode">
        <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
        <cargo-advance-select
          no="loadingPortCode"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_Airport"
          :callback-params="{key:'loadingPortCode'}"
          callback-method-type="value"
          :default-value="valueMatch.loadingPortCode?job.loadingPortCode:''"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="obj=>{valueMatch.loadingPortCode=true;loadingPortCodeChange(obj)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dischargingPortCode.masterVisible" slot="dischargingPortCode">
        <line-label slot="label" :class="elementDict.dischargingPortCode.isRequire ? 'blue' : ''" :label="elementDict.dischargingPortCode.label" />
        <cargo-advance-select
          no="dischargingPortCode"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_Airport"
          :default-value="valueMatch.dischargingPortCode?job.dischargingPortCode:''"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="dischargingPortCode_Change"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPlace.masterVisible" slot="destinationPlace">
        <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
        <cargo-input v-model="job.destinationPlace" :disabled="readonly" no="destinationPlace" :auto-uppercase="true" :placeholder="$t('SeaExport.RequiredItem')" />
      </el-form-item>
      <!--航线-->
      <el-form-item v-if="elementDict.regionName.masterVisible" slot="regionName">
        <line-label slot="label" :class="elementDict.regionName.isRequire ? 'blue' : ''" :label="elementDict.regionName.label" />
        <el-input v-model="job.regionName" no="airline" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.customsDate.masterVisible" slot="customsDate">
        <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
        <el-date-picker v-model="job.customsDate" :disabled="readonly" no="customsDate" type="date" value-format="yyyy-MM-dd" clearable style="width: 100%" />
      </el-form-item>
      <el-form-item v-if="elementDict.etd.masterVisible" slot="etd">
        <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="job.etd"
            :disabled="readonly"
            no="etd"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            clearable
            placeholder=""
            style="flex: 1; width:170px; margin-right: 5px"
            @input="etdChange"
          />
          <span>{{ job.sailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.eta.masterVisible" slot="eta">
        <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="job.eta"
            :disabled="readonly"
            no="eta"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            clearable
            :placeholder="$t('SeaExport.RequiredItem')"
            style="flex: 1; width:170px; margin-right: 5px"
            @input="etaChange"
          />
          <span>{{ job.etaSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.atd.masterVisible" slot="atd">
        <line-label slot="label" :class="elementDict.atd.isRequire ? 'blue' : ''" :label="elementDict.atd.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="job.atd"
            :disabled="readonly"
            no="atd"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            clearable
            style="flex: 1; width:170px; margin-right: 5px"
            @input="atdChange"
          />
          <span>{{ job.atdSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.ata.masterVisible" slot="ata">
        <line-label slot="label" :class="elementDict.ata.isRequire ? 'blue' : ''" :label="elementDict.ata.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="job.ata"
            :disabled="readonly"
            no="ata"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            clearable
            style="flex: 1; width:170px; margin-right: 5px"
            @input="ataChange"
          />
          <span>{{ job.ataSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <template v-if="elementDict.cargoCode.masterVisible" slot="cargoCode">
        <el-form-item :label="$t('SeaExport.CategoryOfGoods')">
          <line-label slot="label" :class="elementDict.cargoCode.isRequire ? 'blue' : ''" :label="elementDict.cargoCode.label" />
          <cargo-advance-select
            no="cargoCode"
            :select-type="selectTypeNames.basic_data_CargoInformation"
            :disabled="readonly"
            filterable
            :callback-params="{key:'cargoCode'}"
            :default-value="job.cargoCode"
            placeholder=" "
            @parentCallBack="txtCargoInformationChangeHandler"
          />
        </el-form-item>
        <el-form-item>
          <cargo-input v-model="job.cargoName" :disabled="readonly || !job.cargoCode" no="cargoName" />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.deliveryAddress.masterVisible" slot="deliveryAddress">
        <line-label slot="label" :class="elementDict.deliveryAddress.isRequire ? 'blue' : ''" :label="elementDict.deliveryAddress.label" />
        <cargo-rich-textarea
          v-model="job.deliveryAddress"
          no="deliveryAddress"
          :disabled="readonly"
          style="height: 110px;"
          @dblclick.native="showAdvanceTextDialog($t('Message.TerminalAddress'),job.deliveryAddress, undefined,val=>{job.deliveryAddress=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.transportSource.masterVisible" slot="transportSource">
        <line-label slot="label" :class="elementDict.transportSource.isRequire ? 'blue' : ''" :label="elementDict.transportSource.label" />
        <cargo-advance-select
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_TransportSource"
          no="transportSource"
          :default-value="job.transportSource"
          :cache="false"
          tag-value="code"
          placeholder=" "
          @parentCallBack="item=>job.transportSource=item.value"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.statisticArea.masterVisible" slot="statisticArea">
        <line-label slot="label" :class="elementDict.statisticArea.isRequire ? 'blue' : ''" :label="elementDict.statisticArea.label" />
        <cargo-advance-select
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_StatisticArea"
          no="statisticArea"
          :default-value="job.statisticArea"
          :cache="false"
          tag-value="code"
          placeholder=" "
          @parentCallBack="item=>job.statisticArea=item.value"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.deliverDate.masterVisible" slot="deliverDate">
        <line-label slot="label" :class="elementDict.deliverDate.isRequire ? 'blue' : ''" :label="elementDict.deliverDate.label" />
        <el-date-picker v-model="job.deliverDate" :disabled="readonly" no="deliverDate" type="date" value-format="yyyy-MM-dd" clearable style="width: 100%" />
      </el-form-item>
      <el-form-item v-if="elementDict.arriveStorageDate.masterVisible" slot="arriveStorageDate">
        <line-label slot="label" :class="elementDict.arriveStorageDate.isRequire ? 'blue' : ''" :label="elementDict.arriveStorageDate.label" />
        <el-date-picker v-model="job.arriveStorageDate" :disabled="readonly" no="arriveStorageDate" type="date" value-format="yyyy-MM-dd" clearable style="width: 100%" />
      </el-form-item>
      <template v-if="elementDict.shipper.masterVisible" slot="shipper">
        <el-form-item label>
          <div style="display: flex;justify-content: flex-end">
            <el-button type="primary" no="CopyFromOtherBill" :disabled="readonly" @click="importPromptTitleDialog.visible=true">{{ $t('SeaExport.CopyFromOtherBill') }}</el-button>
            <el-button type="primary" no="CodeSearching" :disabled="readonly" @click="billAddressDialog.visible=true">{{ $t('SeaExport.CodeSearching') }}</el-button>
          </div>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Shipper')">
          <template slot="label">
            <line-label :class="elementDict.shipper.isRequire ? 'blue' : ''" :label="elementDict.shipper.label" />
            <char-count :form="job" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <div style="display: flex;justify-content: space-between;margin-bottom: 10px">
            <cargo-input v-model="job.shipperCode" :disabled="readonly" no="shipperCode" :auto-uppercase="true" :placeholder="$t('Tool.Code')" style="width:90px;margin-right: 5px" />
            <cargo-advance-select
              no="shipperId"
              filterable
              :disabled="readonly"
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{shipper:true,active:true}"
              :default-value="job.shipperId||''"
              tag-name="englishName"
              style="flex: 1"
              placeholder=" "
              @parentCallBack="shipperAutoCompleteChange"
            />
          </div>
          <cargo-input
            v-model="job.shipperLine1"
            :disabled="readonly"
            no="shipperLine1"
            :auto-uppercase="true"
            :use-read-only="true"
            :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),undefined,splitShipperLine)"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.consignee.masterVisible" slot="consignee">
        <template slot="label">
          <line-label :class="elementDict.consignee.isRequire ? 'blue' : ''" :label="elementDict.consignee.label" />
          <char-count :form="job" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
        </template>
        <div style="display: flex;justify-content: space-between;margin-bottom: 10px">
          <cargo-input v-model="job.consigneeCode" :disabled="readonly" no="consigneeCode" :auto-uppercase="true" :placeholder="$t('Tool.Code')" style="width:90px;margin-right: 5px" />
          <cargo-advance-select
            no="consigneeId"
            filterable
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{consignee:true}"
            :default-value="job.consigneeId||''"
            tag-name="englishName"
            style="flex: 1"
            placeholder=" "
            @parentCallBack="consigneeAutoCompleteChange"
          />
        </div>
        <cargo-input
          v-model="job.consigneeLine1"
          :disabled="readonly"
          no="consigneeLine1"
          :auto-uppercase="true"
          :use-read-only="true"
          :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),undefined,splitConsigneeLine)"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.notify.masterVisible" slot="notify">
        <template slot="label">
          <line-label :class="elementDict.notify.isRequire ? 'blue' : ''" :label="elementDict.notify.label" />
          <char-count :form="job" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
        </template>
        <div style="display: flex;justify-content: space-between;margin-bottom: 10px">
          <cargo-input v-model="job.notifyCode" :disabled="readonly" no="notifyCode" :auto-uppercase="true" :placeholder="$t('Tool.Code')" style="width:90px;margin-right: 5px" />
          <cargo-advance-select
            no="notifyId"
            filterable
            :disabled="readonly"
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{notify:true}"
            :default-value="job.notifyId||''"
            tag-name="englishName"
            style="flex: 1"
            placeholder=" "
            @parentCallBack="notifyAutoCompleteChange"
          />
        </div>
        <cargo-input
          v-model="job.notifyLine1"
          :disabled="readonly"
          no="notifyLine1"
          :auto-uppercase="true"
          :use-read-only="true"
          :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),undefined,splitNotifyLine)"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.quantityActual.masterVisible" slot="quantityActual">
        <line-label slot="label" :class="elementDict.quantityActual.isRequire ? 'blue' : ''" :label="elementDict.quantityActual.label" />
        <auto-number-input
          v-model="job.quantityActual"
          :disabled="readonly"
          no="quantityContract"
          :precision="0"
          :min="0"
          @change="quantityContractChange"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.packing.masterVisible" slot="packing">
        <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
        <cargo-packing-select
          no="packing"
          :disabled="readonly"
          :default-value="job.packing"
          placeholder=" "
          @change="p => {p.key = 'packing';setJobSelectValue(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.weightActual.masterVisible" slot="weightActual">
        <line-label slot="label" :class="elementDict.weightActual.isRequire ? 'blue' : ''" :label="elementDict.weightActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="job.weightActual"
            :disabled="readonly"
            no="weightContract"
            :precision="3"
            :min="0"
            @change="weightContractChange"
          />
          <div style="font-size: 12px;font-weight: normal;color: #404144">
            <span>KGS</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cubageActual.masterVisible" slot="cubageActual">
        <line-label slot="label" :class="elementDict.cubageActual.isRequire ? 'blue' : ''" :label="elementDict.cubageActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="job.cubageActual"
            :disabled="readonly"
            no="cubageContract"
            :precision="3"
            :min="0"
            @change="cubageContractChange"
          />
          <div style="font-size: 12px;font-weight: normal;color: #404144">
            <span>CBM</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.chargeWeight.masterVisible" slot="chargeWeight">
        <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
        <auto-number-input
          v-model="job.chargeWeight"
          :disabled="readonly"
          no="chargeWeight"
          :precision="3"
          :min="0"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoChineseName.masterVisible" slot="cargoChineseName">
        <line-label slot="label" :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''" :label="elementDict.cargoChineseName.label" />
        <div style="position:relative">
          <cargo-input
            v-model="job.cargoChineseName"
            :disabled="readonly"
            no="cargoChineseName"
            type="textarea"
            :rows="3"
            :auto-uppercase="true"
            @dblclick.native="showAdvanceTextDialog(elementDict.cargoChineseName.label,job.cargoChineseName,0,val=>{job.cargoChineseName=val})"
          />
          <char-count :value="job.cargoChineseName" />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cargoEnglishName.masterVisible" slot="cargoEnglishName">
        <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
        <div style="position:relative">
          <cargo-input
            v-model="job.cargoEnglishName"
            :disabled="readonly"
            no="cargoEnglishName"
            type="textarea"
            :rows="3"
            :auto-uppercase="isUppercaseByConfig"
            @dblclick.native="showAdvanceTextDialog(elementDict.cargoEnglishName.label,job.cargoEnglishName,0,val=>{job.cargoEnglishName=val},isUppercaseByConfig)"
          />
          <char-count :value="job.cargoEnglishName" />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.mark.masterVisible" slot="mark">
        <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
        <div style="position:relative">
          <cargo-input
            v-model="job.mark"
            :disabled="readonly"
            no="mark"
            type="textarea"
            :rows="3"
            :auto-uppercase="isUppercaseByConfig"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),job.mark,0,val=>{job.mark=val},isUppercaseByConfig)"
          />
          <char-count :value="job.mark" />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.depositReceived.masterVisible" slot="depositReceived">
        <line-label slot="label" :class="elementDict.depositReceived.isRequire ? 'blue' : ''" :label="elementDict.depositReceived.label" />
        <div style="display: flex;justify-content: space-between">
          <el-input-number v-model="job.depositReceived" :disabled="readonly" no="depositReceived" style="flex-grow: 1" :controls="false" :precision="3" />
          <span>{{ localCurrency }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.remarks.masterVisible" slot="remarks">
        <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
        <cargo-input
          v-model="job.remarks"
          :disabled="readonly"
          no="remarks"
          type="textarea"
          :rows="3"
          :auto-uppercase="true"
          @dblclick.native="showAdvanceTextDialog(elementDict.remarks.label,job.remarks,0,val=>{job.remarks=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.poNo.masterVisible" slot="poNo" :class="poNoRed?'poNoClass':''">
        <line-label slot="label" :class="elementDict.poNo.isRequire ? 'blue' : ''" :label="elementDict.poNo.label" />
        <cargo-input v-if="!openProjectConfig" v-model="job.poNo" :disabled="readonly" no="poNo" :auto-uppercase="true" />
        <cargo-project-select
          v-if="openProjectConfig"
          :disabled="readonly"
          no="poNo"
          :default-value="job.poNo"
          :customer-id="job.customerId"
          @change="changeProject"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.projectName.masterVisible && openProjectConfig" slot="projectName">
        <line-label slot="label" :class="elementDict.projectName.isRequire ? 'blue' : ''" :label="elementDict.projectName.label" />
        <el-input v-model="job.projectName" :disabled="true" no="projectName" />
      </el-form-item>
      <el-form-item v-if="elementDict.freightTerm.masterVisible" slot="freightTerm">
        <line-label slot="label" :class="elementDict.freightTerm.isRequire ? 'blue' : ''" :label="elementDict.freightTerm.label" />
        <cargo-advance-select
          no="freightTerm"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_ShippingTerm"
          callback-method-type="value"
          :default-value="job.freightTerm"
          :callback-params="{key:'freightTerm'}"
          :clearable="false"
          @parentCallBack="setJobSelectValue"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoType.masterVisible" slot="cargoType">
        <line-label slot="label" :class="elementDict.cargoType.isRequire ? 'blue' : ''" :label="elementDict.cargoType.label" />
        <cargo-advance-select
          no="cargoType"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_CargoType"
          :method-params="{air:true}"
          callback-method-type="value"
          :default-value="job.cargoType"
          :callback-params="{key:'cargoType'}"
          :clearable="false"
          @parentCallBack="onCargoTypeChagne"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTermMBL.masterVisible" slot="paymentTermMBL">
        <line-label slot="label" :class="elementDict.paymentTermMBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermMBL.label" />
        <cargo-advance-select
          no="paymentTermMBL"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_PaymentTerm"
          callback-method-type="value"
          :default-value="job.paymentTermMBL"
          :callback-params="{key:'paymentTermMBL'}"
          :clearable="false"
          placeholder=" "
          @parentCallBack="setJobSelectValue"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.incoTerm.masterVisible" slot="incoTerm">
        <line-label slot="label" :class="elementDict.incoTerm.isRequire ? 'blue' : ''" :label="elementDict.incoTerm.label" />
        <cargo-advance-select
          no="incoTerm"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_IncoTerm"
          callback-method-type="value"
          :default-value="job.incoTerm"
          :callback-params="{key:'incoTerm'}"
          :clearable="false"
          placeholder=" "
          @parentCallBack="setJobSelectValue"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.tradeTerm.masterVisible" slot="tradeTerm">
        <line-label slot="label" :class="elementDict.tradeTerm.isRequire ? 'blue' : ''" :label="elementDict.tradeTerm.label" />
        <cargo-advance-select
          no="tradeTerm"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_TradeTerm"
          callback-method-type="value"
          :default-value="job.tradeTerm"
          :callback-params="{key:'tradeTerm'}"
          :clearable="false"
          @parentCallBack="setJobSelectValue"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.transDate.masterVisible" slot="transDate">
        <line-label slot="label" :class="elementDict.transDate.isRequire ? 'blue' : ''" :label="elementDict.transDate.label" />
        <el-date-picker v-model="job.transDate" :disabled="readonly" no="transDate" type="date" value-format="yyyy-MM-dd" clearable style="width: 100%" />
      </el-form-item>
      <el-form-item v-if="elementDict.groundAgentId.masterVisible" slot="groundAgentId">
        <line-label slot="label" :class="elementDict.groundAgentId.isRequire ? 'blue' : ''" :label="elementDict.groundAgentId.label" />
        <cargo-advance-select
          no="groundAgentId"
          filterable
          :disabled="readonly"
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{bookingAgent:true,active:true}"
          :callback-params="{key:'groundAgentId'}"
          callback-method-type="value"
          :default-value="job.groundAgentId||''"
          placeholder=" "
          @parentCallBack="setJobSelectNum"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.txtSalesOffice.masterVisible" slot="txtSalesOffice">
        <line-label slot="label" :class="elementDict.txtSalesOffice.isRequire ? 'blue' : ''" :label="elementDict.txtSalesOffice.label" />
        <el-input v-model="txtSalesOffice" :disabled="true" no="txtSalesOffice" />
      </el-form-item>
      <el-form-item v-if="elementDict.sales.masterVisible" slot="sales">
        <line-label slot="label" :class="elementDict.sales.isRequire ? 'blue' : ''" :label="elementDict.sales.label" />
        <cargo-user-select
          ref="sales"
          :disabled="readonly || isWithinCloseAccountDate"
          no="sales"
          :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
          :default-value="job.sales||''"
          placeholder=" "
          @change="salesChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSalesId.masterVisible" slot="cargoSalesId">
        <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
        <cargo-user-select
          no="cargoSalesId"
          :disabled="readonly"
          :method-params="{category:'role',shape:'salesOfGoods'}"
          :default-value="job.cargoSalesId||''"
          placeholder=" "
          @change="cargoSalesChargeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.salesDepartment.masterVisible" slot="salesDepartment">
        <line-label slot="label" :class="elementDict.salesDepartment.isRequire ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
        <cargo-department-new-select
          :disabled="readonly || !job.sales"
          no="salesOffice"
          :sales-id="Number(job.sales)"
          :enables="true"
          :office-id="job.salesOffice"
          :department-id="Number(job.salesDepartment)"
          @change="departmentChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opOffice.masterVisible" slot="opOffice">
        <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
        <cargo-advance-select
          no="opOffice"
          :disabled="readonly || opOfficeDisabled"
          :select-type="selectTypeNames.basic_data_Office"
          filterable
          :callback-params="{key:'opOffice'}"
          :static-options="cacheOffices"
          callback-method-type="value"
          :default-value="job.opOffice||''"
          placeholder=" "
          @parentCallBack="p=>{job.opOffice=p.value;job.opDepartment=0;opOfficeChargeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opDepartment.masterVisible" slot="opDepartment">
        <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
        <cargo-department-select
          :disabled="readonly || isWithinCloseAccountDate"
          no="opDepartment"
          :enables="true"
          :office-id="Number(job.opOffice)"
          :department-id="Number(job.opDepartment)"
          placeholder=" "
          @change="p=>{job.opDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csr.masterVisible" slot="csr">
        <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
        <cargo-user-select
          no="csr"
          :disabled="readonly"
          :method-params="{category:'role',shape:'csr'}"
          :default-value="job.csr||''"
          placeholder=" "
          :static-options="userPortRoleData.csr"
          @change="csrChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.op.masterVisible" slot="op">
        <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
        <cargo-user-select :disabled="readonly" no="op" :method-params="{category:'role',shape:'op',officeId:$store.getters.currentOffice.code==='HB'?'':$store.getters.currentOfficeId}" :default-value="job.op||''" placeholder=" " :static-options="userPortRoleData.op" @change="opChangeHandler" />
      </el-form-item>
      <el-form-item v-if="elementDict.dc.masterVisible" slot="dc">
        <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
        <cargo-user-select :disabled="readonly" no="dc" :method-params="{category:'role',shape:'doc'}" :default-value="job.dc||''" placeholder=" " :static-options="userPortRoleData.doc" @change="dcChangeHandler" />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerOffice && elementDict.plannerOffice.masterVisible" slot="plannerOffice">
        <line-label slot="label" :class="elementDict.plannerOffice.isRequire ? 'blue' : ''" :label="elementDict.plannerOffice.label" />
        <cargo-office-select
          no="plannerOffice"
          :disabled="true"
          :office-id="Number(job.plannerOffice)"
          @change="p=>{job.plannerOffice=p.value;job.plannerDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerDepartment && elementDict.plannerDepartment.masterVisible" slot="plannerDepartment">
        <line-label slot="label" :class="elementDict.plannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.plannerDepartment.label" />
        <cargo-department-select
          no="plannerDepartment"
          :disabled="readonly"
          :office-id="Number(job.plannerOffice)"
          :enables="true"
          :department-id="Number(job.plannerDepartment)"
          @change="p=>{job.plannerDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.planner.masterVisible" slot="planner">
        <line-label slot="label" :class="elementDict.planner.isRequire ? 'blue' : ''" :label="elementDict.planner.label" />
        <cargo-user-select
          no="planner"
          :disabled="readonly"
          :method-params="{category:'role',shape:'airline'}"
          :default-value="job.planner||''"
          placeholder=" "
          :static-options="userPortRoleData.airline"
          @change="plannerChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.loadingPortOp.masterVisible" slot="loadingPortOp">
        <line-label slot="label" :class="elementDict.loadingPortOp.isRequire ? 'blue' : ''" :label="elementDict.loadingPortOp.label" />
        <cargo-user-select
          no="loadingPortOp"
          :disabled="readonly"
          :method-params="{category:'role',shape:'aiop'}"
          :default-value="job.loadingPortOp||''"
          placeholder=" "
          @change="p=>{job.loadingPortOp=p.value||0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPortOp.masterVisible" slot="destinationPortOp">
        <line-label slot="label" :class="elementDict.destinationPortOp.isRequire ? 'blue' : ''" :label="elementDict.destinationPortOp.label" />
        <cargo-user-select
          no="destinationPortOp"
          :disabled="readonly"
          :method-params="{category:'role',shape:'aiop'}"
          :default-value="job.destinationPortOp||''"
          placeholder=" "
          @change="p=>{job.destinationPortOp=p.value||0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.siteOP.masterVisible" slot="siteOP">
        <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
        <cargo-user-select
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'siteOp'}"
          :default-value="job.siteOP||''"
          placeholder=" "
          :static-options="userPortRoleData.siteOp"
          @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.overseaOp.masterVisible" slot="overseaOp">
        <line-label slot="label" :class="elementDict.overseaOp.isRequire ? 'blue' : ''" :label="elementDict.overseaOp.label" />
        <cargo-user-select
          ref="overseaOp"
          no="overseaOp"
          class="input2"
          :disabled="readonly"
          :default-value="job.overseaOp||''"
          :static-options="userPortRoleData.overseaOp || overseaAgentUsersList"
          :merge-load="true"
          @change="p=>{
            job.overseaOp = p.value
            OverseaCustomerUtils.overseaOpChangeHandler(view, p)
          }"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId1.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId1">
        <line-label slot="label" :class="elementDict.userDefinedRoleId1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId1.label" />
        <cargo-user-select
          ref="userDefinedRoleId1"
          no="userDefinedRoleId1"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
          :default-value="job.userDefinedRoleId1||''"
          :merge-load="true"
          placeholder=" "
          @change="p=>{userDefinedRoleId1Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.userDefinedRoleId2.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId2">
        <line-label slot="label" :class="elementDict.userDefinedRoleId2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId2.label" />
        <cargo-user-select
          ref="userDefinedRoleId2"
          no="userDefinedRoleId2"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
          :default-value="job.userDefinedRoleId2||''"
          :merge-load="true"
          placeholder=" "
          @change="p=>{userDefinedRoleId2Handler(p)}"
        />
      </el-form-item>
      <!-- <div v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.masterVisible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId3">
        <micro-app
          name="child-user-defined-role-ai-master-userDefinedRoleId3"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChangeUI"
        />
      </div>
      <div v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.masterVisible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId4">
        <micro-app
          name="child-user-defined-role-ai-master-userDefinedRoleId4"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChangeUI"
        />
      </div> -->
      <el-form-item v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId3">
        <line-label slot="label" :class="elementDict.userDefinedRoleId3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId3.label" />
        <cargo-user-select
          ref="userDefinedRoleId3"
          no="userDefinedRoleId3"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole3'}"
          :default-value="job.userDefinedRoleId3||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole3"
          @change="p=>{userDefinedRoleId3Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId4">
        <line-label slot="label" :class="elementDict.userDefinedRoleId4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId4.label" />
        <cargo-user-select
          ref="userDefinedRoleId4"
          no="userDefinedRoleId4"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole4'}"
          :default-value="job.userDefinedRoleId4||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole4"
          @change="p=>{userDefinedRoleId4Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId5 && elementDict.userDefinedRoleId5.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId5">
        <line-label slot="label" :class="elementDict.userDefinedRoleId5.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId5.label" />
        <cargo-user-select
          ref="userDefinedRoleId5"
          no="userDefinedRoleId5"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole5'}"
          :default-value="job.userDefinedRoleId5||''"
          :merge-load="true"
          @change="p=>{userDefinedRoleId5Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId6 && elementDict.userDefinedRoleId6.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId6">
        <line-label slot="label" :class="elementDict.userDefinedRoleId6.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId6.label" />
        <cargo-user-select
          ref="userDefinedRoleId6"
          no="userDefinedRoleId6"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole6'}"
          :default-value="job.userDefinedRoleId6||''"
          :merge-load="true"
          @change="p=>{userDefinedRoleId6Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId7 && elementDict.userDefinedRoleId7.masterVisible && isAddUserDefinedRoles" slot="userDefinedRoleId7">
        <line-label slot="label" :class="elementDict.userDefinedRoleId7.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId7.label" />
        <cargo-user-select
          ref="userDefinedRoleId7"
          no="userDefinedRoleId7"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole7'}"
          :default-value="job.userDefinedRoleId7||''"
          :merge-load="true"
          @change="p=>{userDefinedRoleId7Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId8 && elementDict.userDefinedRoleId8.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId8">
        <line-label slot="label" :class="elementDict.userDefinedRoleId8.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId8.label" />
        <cargo-user-select
          ref="userDefinedRoleId8"
          no="userDefinedRoleId8"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole8'}"
          :default-multiple-value="toNumArray(job.userDefinedRoleId8)"
          :disabled="readonly"
          :multiple="true"
          :merge-load="true"
          :placeholder="readonly ? ' ' : ''"
          @change="p=>{job.userDefinedRoleId8=toTxt(p.value)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField1.masterVisible" slot="userDefinedField1">
        <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
        <el-input
          v-model="job.userDefinedField1"
          :disabled="readonly"
          no="userDefinedField1"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField1.label,job.userDefinedField1,0,val=>{job.userDefinedField1=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField2.masterVisible" slot="userDefinedField2">
        <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
        <el-input
          v-model="job.userDefinedField2"
          :disabled="readonly"
          no="userDefinedField2"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField2.label,job.userDefinedField2,0,val=>{job.userDefinedField2=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField3.masterVisible" slot="userDefinedField3">
        <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
        <el-input
          v-model="job.userDefinedField3"
          :disabled="readonly"
          no="userDefinedField3"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField3.label,job.userDefinedField3,0,val=>{job.userDefinedField3=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField4.masterVisible" slot="userDefinedField4">
        <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
        <el-input
          v-model="job.userDefinedField4"
          :disabled="readonly"
          no="userDefinedField4"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField4.label,job.userDefinedField4,0,val=>{job.userDefinedField4=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.taxNature && elementDict.taxNature.masterVisible" slot="taxNature">
        <line-label slot="label" :class="elementDict.taxNature.isRequire ? 'blue' : ''" :label="elementDict.taxNature.label" />
        <el-select
          v-model="job.taxNature"
          :disabled="readonly"
          no="taxNature"
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in TAX_NATURES"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <el-form-item v-if="elementDict.rateType && elementDict.rateType.masterVisible" slot="rateType">
        <line-label slot="label" :class="elementDict.rateType.isRequire ? 'blue' : ''" :label="elementDict.rateType.label" />
        <el-select
          v-model="job.rateType"
          :disabled="readonly"
          no="rateType"
          clearable
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in rateType"
            :key="index"
            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <div slot="ticketsInfo" class="section">
        <div class="form-row">
          <span class="title">{{ $t('SeaExport.TicketsInfo') }}</span>
          <div style="display: flex;justify-content: flex-start;margin-bottom: 5px;line-height: 28px">
            <span>{{ $t('SeaExport.TotalTickets') }}:</span>
            <span style="margin-right: 5px;">{{ job.lclSlaves ? job.lclSlaves.length : 0 }}</span>
            <div v-show="readonly&&viewSource==='bookingWorkspace'" class="triggers">
              <el-button no="NewTickets" type="primary" @click="addTicket_clickHandler">{{ $t('SeaExport.NewTickets') }}</el-button>
              <el-button no="EditTickets" type="primary" @click="editTicket_clickHandler">{{ $t('SeaExport.EditTickets') }}</el-button>
              <el-button no="AddTickets" type="primary" @click="queryAILclDialog.visible=true">{{ $t('SeaExport.AddTickets') }}</el-button>
              <el-button no="AddTickets" type="danger" @click="removeTicket_clickHandler">{{ $t('SeaExport.RemoveTickets') }}</el-button>
            </div>
          </div>
          <div style="min-height: 200px;flex-direction: column">
            <cargo-ag-grid
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="lclSlaves"
              style="height:300px;"
              @gridReady="params=>{gridApi=params.api}"
            />
            <div style="display: flex;justify-content: flex-end;">
              <div>{{ $t('SeaExport.TotalNumberOfPackages') }}：{{ lbTotal.lblTotalQuantity }}</div>
              <div style="margin-left: 10px;">{{ $t('SeaExport.TotalWeight2') }}：{{ lbTotal.lblTotalWeight }}</div>
              <div style="margin-left: 10px;">{{ $t('SeaExport.TotalCubage') }}：{{ lbTotal.lblTotalCubage }}</div>
            </div>
          </div>
        </div>
      </div>
    </tab-booking-master-UICustom-layout>
    <!-- 单号抄录 -->
    <import-prompt-title-dialog :visible.sync="importPromptTitleDialog.visible" :lob="job.lob" @selected="onExcerptionChangeFunc" />
    <!-- 代码检索 -->
    <import-bill-address-title-dialog :visible.sync="billAddressDialog.visible" :job="job" @callback="codeSearchCallback" />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="665px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :text-chars="advanceTextDialog.textChars"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="-1"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="confirm" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 加入拼箱工作单查询弹窗 -->
    <query-ai-lcl-dialog :visible.sync="queryAILclDialog.visible" :job="job" @callback="slavedAddedHandler" />
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import tabBookingMasterUICustomLayout from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingMasterUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabBookingMaster from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingMaster.vue'
import StrUtils from '@/utils/StrUtils'
import microApp from '@micro-zoe/micro-app'
import { toNumArray, toTxt } from '@/utils/commonUtil'

export default {
  name: 'TabBookingMasterUICustom',
  components: { tabBookingMasterUICustomLayout },
  extends: tabBookingMaster,
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      userDefinedRoleDataUI: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole3',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'userDefinedRoleId3',
        fieldData: this.job ? this.job.userDefinedRoleId3 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole3',
        staticOptions: null,
        mergeLoad: true
      }
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    toTxt,
    toNumArray,
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
    },
    loadPageConfig() {
      const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.AI_BOOKING_BASIC, this.$store.getters.currentOfficeId)
      this.elementBlocks = pageConfig.elementBlocks
      this.elementDict = pageConfig.elementDict
      this.fieldDict = pageConfig.fieldDict
    },
    async validateForm() {
      const form = this.job
      for (const key in this.fieldDict) {
        const field = this.fieldDict[key]
        if (field.masterVisible && field.isRequire) {
          if (key === 'secondaryCustomJobType') {
            if (!(this.job.customJobType && this.secondaryCustomJobTypeList.length > 0)) {
              continue
            }
          }
          if (key === 'projectName') {
            continue
          }
          if (key === 'measurements') {
            continue
          }
          if (key === 'userDefinedRoleId1' || key === 'userDefinedRoleId2') {
            if (!this.isAddUserDefinedRoles) {
              continue
            }
          }
          if (key === 'designationAgent') {
            if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingMaster')
            }
          } else if (key === 'cargoCode') {
            if (StrUtils.isEmpty(form.cargoCode) || StrUtils.isEmpty(form.cargoName)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingMaster')
            }
          } else if (key === 'taxNature') {
            if (form[key] === '' || form[key] === null) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else {
            if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingMaster')
            }
          }
        }
      }
      if (this.elementDict.jobSoNo.masterVisible && this.elementDict.jobSoNo.isRequire) {
        if (StrUtils.isEmpty(form.jobSoNo)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.jobSoNo.label]), 'tabBookingMaster')
        }
      }
      if (this.elementDict.regionName.masterVisible && this.elementDict.regionName.isRequire) {
        if (StrUtils.isEmpty(form.regionName)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.regionName.label]), 'tabBookingMaster')
        }
      }
      if (this.elementDict.shipper.masterVisible && this.elementDict.shipper.isRequire) {
        let shipperLine = ''
        for (let i = 1; i <= 7; ++i) {
          shipperLine += form['shipperLine' + i]
        }
        if (StrUtils.isEmpty(shipperLine) && StrUtils.isEmpty(form.shipperCode)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.shipper.label]), 'tabBookingMaster')
        }
      }
      if (this.elementDict.consignee.masterVisible && this.elementDict.consignee.isRequire) {
        let consigneeLine = ''
        for (let i = 1; i <= 7; ++i) {
          consigneeLine += form['consigneeLine' + i]
        }
        if (StrUtils.isEmpty(consigneeLine) && StrUtils.isEmpty(form.consigneeCode)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.consignee.label]), 'tabBookingMaster')
        }
      }
      if (this.elementDict.notify.masterVisible && this.elementDict.notify.isRequire) {
        let notifyLine = ''
        for (let i = 1; i <= 7; ++i) {
          notifyLine += form['notifyLine' + i]
        }
        if (StrUtils.isEmpty(notifyLine) && StrUtils.isEmpty(form.notifyCode)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.notify.label]), 'tabBookingMaster')
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return await this.superFunction()
    },
    setUserDefinedRoleDataUI() {
      return
      // userDefinedRoleId3
      const userDefinedRoleData3 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData3.fieldData = this.job.userDefinedRoleId3 || ''
      userDefinedRoleData3.disabled = this.readonly
      userDefinedRoleData3.filedLable = 'CargoMsg.Cargo_userDefinedRole3'
      userDefinedRoleData3.no = 'userDefinedRoleId3'
      userDefinedRoleData3.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData3.category = 'role'
      userDefinedRoleData3.shape = 'userDefinedRole3'
      userDefinedRoleData3.staticOptions = this.userPortRoleData.userDefinedRole3
      userDefinedRoleData3.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData3)
      microApp.forceSetData('child-user-defined-role-ai-master-userDefinedRoleId3', userDefinedRoleData3)
      // userDefinedRoleId4
      const userDefinedRoleData4 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData4.fieldData = this.job.userDefinedRoleId4 || ''
      userDefinedRoleData4.disabled = this.readonly
      userDefinedRoleData4.filedLable = 'CargoMsg.Cargo_userDefinedRole4'
      userDefinedRoleData4.no = 'userDefinedRoleId4'
      userDefinedRoleData4.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData4.category = 'role'
      userDefinedRoleData4.shape = 'userDefinedRole4'
      userDefinedRoleData4.staticOptions = this.userPortRoleData.userDefinedRole4
      userDefinedRoleData4.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData4)
      microApp.forceSetData('child-user-defined-role-ai-master-userDefinedRoleId4', userDefinedRoleData4)
    },
    userDefinedRoleDataChangeUI(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleDataUI()
        } else {
          if (e.detail.data.no === 'userDefinedRoleId3') {
            this.job.userDefinedRoleId3 = e.detail.data.fieldData
            this.userDefinedRoleId3Handler(this.job.userDefinedRoleId3)
          } else if (e.detail.data.no === 'userDefinedRoleId4') {
            this.job.userDefinedRoleId4 = e.detail.data.fieldData
            this.userDefinedRoleId4Handler(this.job.userDefinedRoleId4)
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
#app .section ::v-deep {
  .job-no-color.el-input {
    .el-input__inner {
      background: #99ff66 !important;
    }
  }
  .red {
    .el-input__inner {
      color: #f56c6c !important;
    }
  }
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
</style>
